/** Web app secure launch (M29, WP-M29-LAUNCH-WEB): the launch page, the state-bound start, the dead end and "Chatting as". `embed` is the frame (iframe) variant. No dots inside key segments. */
export const webappLaunch = {
  launching: {
    title: "Opening your chat",
    body: "Signing you in securely…",
  },
  rateLimited: {
    body: "Too many attempts right now. Please wait a moment and try again.",
    retry: "Try again",
  },
  deadEnd: {
    title: "This chat link has expired",
    body: "Links work once and only for a short time, to keep your records private. Start the chat again from the site.",
    returnTo: "Back to {{site}}",
    note: "Nothing about you was shared through this link.",
  },
  start: {
    title: "Taking you to sign in",
    body: "We'll bring you back here signed in.",
  },
  verifiedOnly: {
    title: "Open this chat from the site",
    body: "This assistant is for verified customers. Open it from the {{org}} site, or sign in below.",
  },
  header: {
    chattingAs: "Chatting as {{name}}",
    chattingAsTier: "Chatting as {{name}} · {{tier}}",
    customerFallback: "Customer",
    returnTo: "Back to {{site}}",
  },
  embed: {
    reconnecting: {
      title: "Reconnecting you to the chat",
      body: "Signing you in again securely…",
    },
    ended: {
      title: "Your chat session ended",
      body: "Chats close after a while to keep your records private. Reconnect to carry on, or reload the page this chat sits on.",
      reconnect: "Reconnect",
      failed: "We couldn't reconnect from here. Reload the page this chat sits on to continue.",
    },
  },
  oidc: {
    button: "Sign in with your {{org}} account",
    buttonHint: "You'll go to {{org}}'s own sign-in and come straight back.",
    redirecting: "Taking you to sign in…",
    framedTitle: "Open the chat from the {{org}} site",
    framedBody: "Sign-in with the {{org}} account can't run inside this page. Open the chat from the {{org}} site and it signs you in for you.",
    errors: {
      failed: "We couldn't sign you in with your {{org}} account. Try again, or use another way below.",
      unavailable: "Sign-in with your {{org}} account isn't available right now. Try again in a moment, or use another way below.",
      framed: "Sign-in with your {{org}} account can't run inside a frame. Open the chat from the {{org}} site.",
      expired: "That sign-in took too long or was already used. Start again.",
      blocked: "This account can't use the chat. Contact {{org}} if you think that's a mistake.",
    },
  },
} as const;
